import { render, staticRenderFns } from "./refundDetail.vue?vue&type=template&id=ebfa0d60&scoped=true"
import script from "./refundDetail.vue?vue&type=script&lang=js"
export * from "./refundDetail.vue?vue&type=script&lang=js"
import style0 from "./refundDetail.vue?vue&type=style&index=0&id=ebfa0d60&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebfa0d60",
  null
  
)

export default component.exports